module.exports = __webpack_public_path__ + "img/main_small.ac9ccc6c.webp";